export default "__VITE_ASSET__B5sf6jfj__"